import type { ObjectBase } from './objectBase.interface'
import type { Workflow } from './workflow.interface'
import type { SubscriptionKind } from './subscription.interface'
import type { SubscriptionRole } from './subscription-role-gpu-limit.interface'
import type { NordyUser } from './user.interface'

export enum JobStatus {
  Pending = 'Pending',
  Connecting = 'Connecting',
  Connected = 'Connected',
  Running = 'Running',
  Done = 'Done',
  ExecuteError = 'ExecuteError',
  ConnectError = 'ConnectError',
  WorkerConnectError = 'WorkerConnectError',
  InvalidPrompt = 'InvalidPrompt',
  Canceled = 'Canceled',
  ExecutionTimeout = 'ExecutionTimeout',
  ForceTimeout = 'ForceTimeout', // 무한러닝인채로 끝났을 경우에 스케쥴러에서 강제로 업데이트했을경우
  UnknownError = 'UnknownError', // 알 수 없는 에러
  WorkerShutdownError = 'WorkerShutdownError' // running중이던 job의 워커가 원격 또는 도커 종료되었을때
}

export type JobStatusAggregate = {
  [key in JobStatus]?: number
}

export enum CreationKind {
  Comfy = 'comfy',
  Easyapp = 'easyapp',
  Figma = 'figma',
  WorkflowApi = 'workflow-api',
  Generator = 'generator'
}

export interface Job extends ObjectBase {
  user: NordyUser
  status: JobStatus
  message: string
  nordyHostname: string
  nordyTargetId: string
  nordyWsProtocol: string
  workflow: Workflow
  prompt: string
  startAt: Date
  endAt: Date
  duration: number
  region: string
  priority: number
  createdByAdmin: boolean // 관리자 직접 생성 여부, 통계를 위한 인덱싱용, Pre save에서 업데이트
  promptResult: PromptResult
  creationKind: CreationKind
  meta: {
    userSubscriptionKind: SubscriptionKind
    userSubscriptionItem: string
    userSubscriptionRole: SubscriptionRole
    connectedAt: Date
    connectedDuration: number
    apiBody: {
      [key: string]: unknown
    }
    apiOutputs: {
      [key: string]: {
        active: boolean
        order: number
      }
    }
    workflowApiOutputsEmbed: {
      [key: string]: {
        order: number
        name: string
      }
    }
    userCacheHit?: boolean
  }
  workflowApi: string
  executeException?: ComfyExcuteException
  validateException?: ComfyValidateException
}

export interface PromptResult {
  prompt_id: string
  number: number
  node_errors: Record<
    string,
    {
      class_type: string
      errors: {
        type: string
        message: string
        details: string
        extra_info?: Record<string, unknown>
      }[]
      dependent_outputs: unknown[]
    }
  >
  status: number
  error?: string | { type: string; message: string; details: string }
}

export interface RetentionUser {
  email: string
}

export interface ActiveUser {
  email: string
  count: number
}

export interface NJob {
  meanJob: number | null
  nJobs: number
  nActiveJobs: number
  nActiveUsers: ActiveUser[]
  nRawActiveUsers: number[]
  sigmaActiveUsers: number | null
}

export interface Retention {
  nUsers: RetentionUser[]
  jobs: NJob[]
}

export interface ComfyExcuteException {
  node_id: string
  exception_message: string
  exception_type: string
  traceback: string[]
}

export interface ComfyValidateException {
  type: string
  message: string
  details: string
  extra_info: Record<string, unknown>
}
